import React, { FC } from 'react';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';
import { Node } from 'src/common/interfaces/node.interface';
import { useEditorContext } from 'src/store/editor';
import { SmallPanel } from 'src/common/ui/small-panel';
import { LinkRegularIcon } from 'src/monet/icons';
import { useJourneyAliasUrlClipboardCopy } from 'src/common/use-journey-alias-url-clipboard-copy.hook';

interface ContentCopyUrlToStepPanelProps
  extends Pick<
    JourneyMenuPropsInterface,
    'renderOrigin' | 'openRef' | 'closeRef' | 'onOpen' | 'onClose' | 'placement' | 'offset'
  > {
  node: Node;
  onBack?: () => void;
  children?: any;
  open?: boolean;
}

export const ContentCopyUrlToStepPanel: FC<ContentCopyUrlToStepPanelProps> = ({
  node,
  renderOrigin,
  openRef,
  closeRef,
  placement,
  offset,
  onOpen,
  onClose,
  onBack,
}) => {
  const { journey } = useEditorContext();

  const menuItemClasses =
    'text-bedrock-p text-bedrock-black text-left flex w-full items-start space-x-sm hover:opacity-80';

  const { copyNodeUrlToClipboard } = useJourneyAliasUrlClipboardCopy({
    onCopySuccess: onClose,
    successNotificationMessage: 'Step URL has been copied to clipboard',
  });

  return (
    <SmallPanel
      placement={placement}
      offset={offset}
      openRef={openRef}
      closeRef={closeRef}
      openAfterMount
      fixed
      hasBackButton
      containerClassName='max-h-[40vh] overflow-y-auto'
      onBack={onBack}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={renderOrigin}
    >
      <div className='flex flex-col space-y-sm'>
        {journey.aliases.map((alias: JourneyAlias, idx: number) => (
          <button type='button' className={menuItemClasses} onClick={() => copyNodeUrlToClipboard(alias, node)}>
            <div className='flex flex-shrink-0'>
              <LinkRegularIcon />
            </div>
            <span>{alias.name}</span>
          </button>
        ))}
      </div>
    </SmallPanel>
  );
};
